module.exports = {
  '菜单': 'Menu',
  '首页': 'Home',
  '贡献': 'Contribution',
  '理财': 'Finance',
  '资产': 'Assets',
  '我的社群': 'Community',
  '分红节点': 'Bonus Node',
  '邀请好友': 'Invite Friends',
  '制度说明': 'Description',
  '复制成功': 'Replicating Success',
  '复制失败': 'copy failed',
  '公告列表': 'Announcement List',
  '公告详情': 'Announcement Details',
  '没有更多了': 'No more',
  '流通量': 'Circulation',
  '总发行量': 'Total Issuance',
  '低池U量': 'Low pool U quantity',
  '低池ACT量': 'Low pool ACT quantity',
  '当前分红节点：': 'Current: ',
  'ACT币趋势': 'ACT coin trend',
  '当前价格': 'Price',
  '选择支付方式': 'Select payment method',
  '我的贡献': 'My contribution',
  '确定': 'Confirm',
  '应支付': 'Payable',
  '请输入贡献数量': 'Please enter the contribution quantity',
  '请输入交易密码': 'Please enter password',
  '贡献数量': 'Contribution quantity',
  '交易密码': 'Transaction password',
  '复投': 'Reinvest',
  '复投成功': 'Reinvest success',
  'USDT+卡牌': 'USDT+Card',
  'ACT+卡牌': 'ACT+Card',
  '可用': 'Available',
  '请输入数量': 'Please enter the quantity',
  '请输入复投数量': 'Please enter the reinvestment quantity',
  '请勿重复提交': 'Do not submit repeatedly',
  '我的理财': 'My finance',
  '参与理财': 'Participate',
  '价格': 'Price',
  '收益率': 'Yield',
  '天': 'Day',
  '理财收益率': 'Yield',
  '理财金额': 'Amount',
  '周期': 'Cycle',
  '到期': 'Due',
  '当期收益': 'Current earnings',
  '已结束': 'Finished',
  '理财中': 'In progress',
  '参与成功': 'Participate success',
  '卡牌': 'Card',
  '互转': 'Transfer',
  '闪兑': 'Flash exchange',
  '提现': 'Withdraw',
  '互转记录': 'Transfer',
  '闪兑记录': 'Flash',
  '提现记录': 'Withdraw',
  '手续费': 'Fee',
  '提现地址': 'Address',
  '兑换方式': 'Exchange method',
  '转账地址': 'Transfer address',
  '时间': 'Time',
  'ACT兑卡牌': 'ACT exchange card',
  'ACT兑USDT': 'ACT exchange USDT',
  'USDT兑ACT': 'USDT exchange ACT',
  '钱包': 'Wallet',
  '操作时间': 'Operation time',
  '流水明细': 'Flow details',
  '请输入接收地址': 'Eter the receiving address',
  '请输入互转数量': 'Enter the transfer quantity',
  '互转数量': 'Transfer',
  '互转说明': 'Transfer description',
  '接收地址': 'Address',
  '实际到账': 'Arrival',
  '互转成功': 'Transfer success',
  '自动计算': 'Auto calculate',
  '闪兑说明': 'Flash description',
  '实际销毁': 'Actual destruction',
  '闪兑数量': 'Flash',
  '闪兑币种': 'Currency',
  '请输入闪兑数量': 'Enter the flash quantity',
  '操作成功': 'Operation success',
  '提现数量': 'Withdraw',
  '最小提现数量': 'Minimum withdrawal',
  '请输入提现地址': 'Enter the withdrawal address',
  '提现说明': 'Withdraw description',
  '请输入提现数量': 'Enter the withdrawal quantity',
  '账号': 'Account',
  '贡献值': 'Contribution',
  '我的推荐': 'My recommendation',
  '节点团队业绩': 'Team performance',
  '理财团队一月内业绩': 'Performance of the month',
  '理财团队一月以上业绩': 'Performance of one month or more',
  '直推人数': 'Direct push',
  '级别': 'Level',
  '分红点': 'Bonus node',
  '团队人数': 'Team',
  '我的贡献': 'My contribution',
  '权益值': 'Equity',
  '推广链接': 'Promotion link',
  '当前系统分红节点': 'Current bonus node',
  '我的节点': 'My node',
  '节点记录': 'Node record',
  '节点数量': 'Node',
  '节点排名': 'Node ranking',
  '名次': 'Ranking',
  '数量': 'Quantity',
  'DAB数量': 'DAB',
  '地址': 'Address',
  '到账地址': 'Address',
  '是否有效': 'Effective',
  '有效节点': 'Effective node',
  '无效节点': 'Invalid node',
  '兑换时间': 'Exchange time',
  '复制并保存': 'Copy and save',
  '到期收益': 'Due earnings',
  '复制链接': 'Copy link',
  '消耗数量': 'Consumption',
  '待审核': 'Review',
  '通过': 'Pass',
  '驳回': 'Reject',
  '转账中': 'Transfer',
  '驳回原因': 'Reject reason',
  '充值说明': 'Recharge description',
  '充值数量': 'Recharge',
  '请输入充值数量': 'Enter the recharge quantity',
  '充值': 'Recharge',
  '请确认新密码': 'Please confirm the new password',
  '请输入新密码': 'Please enter the new password',
  '请输入旧密码': 'Please enter the old password',
  '修改密码': 'Password',
  '支付': 'Pay',
  '支付数量': 'Pay Numb',
  '支付币种': 'Pay Curry',
  '实际支付': 'Actual pay',
  '来源地址': 'Source address',
  '成功': 'Success',
  '检测中': 'Testing',
  '充值地址': 'Recharge address',
  '充值记录': 'Recharge record',
  '失败': 'Fail',
  '余额不足': 'Insufficient balance',

  "矿机": "Mining machine",
  "我的矿机": "My mining machine",
  "已购买矿机": "Redeemed mining machine",
  "台": "platform",
  "开始挖矿": "Start mining",
  "进度": "speed of progress",
  "动态分红": "Dynamic dividends",
  "查看更多": "View more",
  "领导分红": "Leadership dividends",
  "提示": "Tips",
  "取消": "cancel",
  "请先购买矿机": "Please purchase the mining machine first",
  "矿机商城": "Mining Machinery Mall",
  "价值": "value",
  "购买": "purchase",
  "购买次数": "Purchase frequency",
  "过期矿机": "Expired mining machine",
  "运行次数": "Runs",
  "购买日期": "purchase date",
  "到期日期": "Expiration date",
  "已过期": "Expired ",
  "产出": "produce",
  "USDT兑ACTs": "USDT exchange ACTs",
  "冻结": "freeze",
  "启动": "start",
  "运行中": "Runing",
  "暂无收汇地址": "No collection address",
  "钱包提现": "Wallet withdrawal",
  "银行卡提现": "Bank card withdrawal",
  "人民币": "RMB",
  "美金": "dollar",
  "英镑": "pound",
  "欧元": "euro",
  "聊天": "chat",
  "请先维护提现银行卡信息": "Maintain withdrawal bank card information",
  "身份输入": "Identity input",
  "身份信息": "Identity information",
  "姓名": "full name",
  "请输入姓名": "Please enter your name",
  "姓拼音": "Pinyin of surname",
  "请输入姓拼音, 如`Zhang`": "Please enter your surname pinyin, such as `Zhang`",
  "请输入姓拼音": "Please enter your surname pinyin",
  "名拼音": "Name Pinyin",
  "请输入名拼音, 如`San`": "Please enter the pinyin of the name, such as `San`",
  "请输入名拼音": "Please enter the pinyin of the name",
  "证件信息": "Document information",
  "国籍": "nationality",
  "证件类型": "Document type ",
  "证件号": "ID number",
  "请输入证件号": "Please enter your identification number",
  "银行卡信息": "Bank card information",
  "银行名称": "Bank name",
  "请输入银行名称": "Please enter the bank name",
  "银行卡号": "Bank card number",
  "请输入银行卡号": "Please enter your bank card number",
  "开户行": "Opening bank",
  "请输入开户行": "Please enter the bank of account opening",
  "中华人民共和国": "The People's Republic of China",
  "美国": "U.S.A",
  "英国": "britain",
  "户口本": "Household registration book",
  "护照": "passport",
  "请上传银行卡照片（选填）": "Please upload a photo of your bank card (optional)",
  "去添加": "Go add it",
  "完善信息": "Improve information",
  "邀请人": "Inviter",
  "请输入邀请码": "Please enter the invitation code",
  "请输入6位纯数字": "Please enter 6 pure digits",
  "请复制聊天链接，在手机默认浏览器中打开使用！": "Please copy the chat link and open it in the default browser on your phone!",
  "复制": "copy",
  "语音聊天": "Voice chat",
  "数量": "quantity",
  "已收益": "earned",
  "每日收益": "daily earnings",
  "我的理财明细": "My financial details",
  "币种": "currency",
  "类型": "type",
  "理财收益": "financial income",
  "理财记录": "financial list",
  "请切换币安链": "Please switch to the Binance chain",
  "充值中，请不要返回！": "Recharge in progress, please do not return!",
  "提现未开启": "Withdrawal not enabled",

  "收货地址": "Address",
  "新增地址": "Add New Address",
  "编辑": "Edit",
  "删除": "Delete",
  "默认": "Default",
  "保存": "Save",

  "请输入收货人姓名": "Please Enter Recipient's Name",
  "收货人": "Recipient",
  "请输入收货人手机号": "Please Enter Recipient's Phone Number",
  "手机号": "Phone Number",
  "所在地区": "Location/Area",
  "请选择地区": "Please Select Area",
  "请输入详细地址：如道路、街道、楼号等": "Please Enter Detailed Address: Such as Road, Street, Building Number, etc.",
  "设为默认收货地址": "Set as Default Shipping Address",
  "编辑地址": "Edit Address",
  "确定要删除此地址吗?": "Are You Sure to Delete This Address?",

  "修改地址成功": "Address Updated Successfully",
  "添加地址成功": "Address Added Successfully",
  "删除成功": "Deleted Successfully",

  "提交订单": "Place Order",
  "提交": "Submit",
  "暂无收汇地址": "Add Shipping Address",

  "品鉴商城": "Mining Machinery Mall",

  "快递公司": "Courier Company",
  "快递单号": "Tracking Number",
  "我的订单": "My Orders",
  "我的收益": "My Earnings",
  "过期收益": "Expired Earnings",
  "选择这个地址": "Choose This Address",
  "请选择您的地区": "Please Select Your Area",
  "支付失败": "Payment Failed",

  "请选择语言": "Please select language",
  "行情": "Market",
  "我的团队": "My Team",
  "交易规则": "Trading Rules",
  "关于我们": "About Us",
  "公告中心": "Announcements",

  "今日分红": "Dividend",
  "算力值": "Hashrate Value",
  "投资数量": "Investment Amount",
  "投资倍数": "Investment Multiplier",
  "兑换": "Exchange",
  "用户": "User",
  "金额": "Amount",

  "我的钱包": "My Wallet",
  "请先从左上角连接钱包": "Please connect your wallet from the top-left corner first",
  "确定要退出吗": "Are you sure you want to log out",

  "我的钱包地址": "My Wallet Address",
  "上级钱包地址": "Referrer's Wallet Address",
  "累计收益": "Total Earnings",
  "我的算力": "My Hashrate",
  "总算力": "Total Hashrate",

  "可用数量": "Available Amount",
  "提现范围": "Withdrawal Range",
  "提现时间": "Withdrawal Time",

  "成交量": "Trading Volume",
  "矿工数": "Number of Miners",

  "请安装钱包插件": "Please install a wallet extension",
  "请手动切换到币安链": "Please manually switch to BNB Chain",
  "用户取消连接": "User canceled the connection",
  "签名被取消": "Signature was canceled",
  "登录失败": "Login failed",

  "团队业绩": "Team Performance",
  "算力": "Hashrate",
  "设置等级": "Set Level",
  "确定要设置等级吗": "Are you sure you want to set the level?",

  "级别": "Level",
  "确定要设置级别吗": "Are you sure you want to set the level?",

  "个人算力": "Hashrate",
  '会员等级': 'Member Level',
  '投资记录': 'Investment Record',
  '投资': 'Investment',
  '直推列表': 'Direct Push List',
  '请输入账号': 'Please enter the account',
  '直推有效人数': 'Effective Number',
  '搜索': 'Search',
  '全网总算力': 'Total Hashrate',
  '显示团队': 'Show Team',
  '显示直推': 'Show Direct Push',
  '您要绑定的邀请码': 'The invitation code you want to bind',
  '您需要有绑定的邀请码': 'You need to have a bound invitation code',
  '全部': 'All',
  '累计分红': 'Total Dividends',

}